import queryKeys from '@/constants/queryKeys';
import { createBrandedContent } from '@/services/api/requests/content';
import { TCreateBrandedContentPayload } from '@/types/Content.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// No toast/navigation here — the create flow chains image uploads and an optional
// publish before reporting success, so the caller orchestrates those via mutateAsync.
const useCreateBrandedContent = () => {
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (payload: TCreateBrandedContentPayload) => createBrandedContent(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.all] });
    },
  });

  return { isPending, mutateAsync };
};

export default useCreateBrandedContent;
